import { render, staticRenderFns } from "./UpdateSmsTemplatesModal.vue?vue&type=template&id=6d486fdf"
import script from "./UpdateSmsTemplatesModal.vue?vue&type=script&lang=js"
export * from "./UpdateSmsTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports